import { render, staticRenderFns } from "./callback-add-or-update.vue?vue&type=template&id=49a0bfb4&scoped=true&"
import script from "./callback-add-or-update.vue?vue&type=script&lang=js&"
export * from "./callback-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./callback-add-or-update.vue?vue&type=style&index=0&id=49a0bfb4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a0bfb4",
  null
  
)

export default component.exports